module.exports = __webpack_public_path__ + "img/neeraj-image.4ddbb268.jpeg";